import { render } from "./consentdocumentupload.vue?vue&type=template&id=59993030&scoped=true"
import script from "./consentdocumentupload.js?vue&type=script&lang=js"
export * from "./consentdocumentupload.js?vue&type=script&lang=js"

import "./consentdocumentupload.vue?vue&type=style&index=0&id=59993030&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59993030"]])

export default __exports__